export default "/assets/workfiles/crono_blanc.svg"